import { useState, useEffect, useCallback } from 'react'
import { fetchUserProfile } from './userProfiles'

export default function useGetUserName(userId) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchUser = useCallback(async () => {
    if (!userId) return
    setLoading(true)
    setError(null)
    try {
      const userData = await fetchUserProfile(userId)
      if (userData) {
        setUser(userData)
      } else {
        setError(new Error('User not found'))
      }
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [userId])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return { user, loading, error, refetch: fetchUser }
}
